export default [
  {
    path: 'scan-qr',
    name: 'scan-qr',
    component: () => import('./ScanQRPage.vue')
  },
  {
    path: 'camera-permission',
    name: 'camera-permission-denied',
    component: () => import('./CameraPermissionPage.vue')
  }
]
